module.exports = __webpack_public_path__ + "static/media/pencil.fe9ac7bc.webp";